import MyTeamSubordinate from "../components/MyTeamSubordinate";
import useMyTeamSubordinate from "../hooks/useMyTeamSubordinate";

function MyTeamSubordinatePage() {
    const myTeamSubOrdinateProps = useMyTeamSubordinate();
    return <MyTeamSubordinate {...myTeamSubOrdinateProps} />
}

export default MyTeamSubordinatePage;